import { AppNameToId } from '../constants';
// Read app id in path and return friendly app Id or GUID app id as specified if this app can be hosted at root
// Return undefined if this app cannot be hosted at root
export var tryGetAppHostedAtRoot = function (path, appsHostedAtRoot, returnFriendlyAppId) {
    if (!path || !appsHostedAtRoot || !appsHostedAtRoot.length) {
        return undefined;
    }
    // Try get app id from path
    var appIdInPath = '';
    if (path.indexOf('/') === -1) {
        // path is just the app id
        appIdInPath = path;
    }
    else {
        // path looks like /v2/m365apps/chat or /v2/chat/1234
        var pathWithoutPrefix = path
            .replace('/pwa', '')
            .replace('/embed', '')
            .replace('/v2', '')
            .replace('/v3', '');
        var segments = pathWithoutPrefix.indexOf('/m365apps') > -1
            ? pathWithoutPrefix.split('/m365apps')[1].split('/')
            : pathWithoutPrefix.split('/');
        if (segments.length >= 2 && segments[1]) {
            appIdInPath = segments[1];
        }
    }
    if (appIdInPath) {
        if (appsHostedAtRoot.includes(appIdInPath)) {
            // appIdInPath is already a friendly app id
            return returnFriendlyAppId ? appIdInPath : AppNameToId[appIdInPath];
        }
        // Treat appIdInPath as a guid app id.
        var friendlyAppId = Object.keys(AppNameToId).find(function (key) { return AppNameToId[key] === appIdInPath; });
        if (friendlyAppId && appsHostedAtRoot.includes(friendlyAppId)) {
            return returnFriendlyAppId ? friendlyAppId : appIdInPath;
        }
    }
    return undefined;
};
//# sourceMappingURL=tryGetAppHostedAtRoot.js.map